import { ApiEndpoints } from "@shared/api/api-endpoints";
import { mxApiClient } from "@shared/api/clients/apiClientFactory";

export const getOperations = async (
    utilityId: string | number,
    tab: string,
    page: number,
    limit: number,
    searchData?: string
): Promise<any> => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
        "mx",
        "operation",
        (query) => {
            query.push("remote_utility_id", utilityId);
            if (tab) query.push("tab", tab);
            if (page) query.push("page", page);
            if (limit) query.push("limit", limit);
            if (searchData) query.push("search_data", searchData);
            return query;
        }
    );
    const response = await mxApiClient.get(url);
    return response.data ?? {};
};

export const getResourceOperationChoices = async (): Promise<any> => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
        "mx",
        "choices/resource_operation",
        (query) => {
            return query;
        }
    );
    const response = await mxApiClient.get(url);
    return response.data ?? [];
};

export const addOperation = async (payload: any): Promise<any> => {
    const url = ApiEndpoints.createUrlWithQueryParameters("mx", "operation", (query) => query);
    const response = await mxApiClient.post(url, payload);
    return response.data;
};

export const getOperationDetail = async (
    operationId: string | number,
    utilityId: string | number,
    tab: string,
    page: number = 1,
    limit: number = 10
): Promise<any> => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
        "mx",
        `operation/${operationId}/detail`,
        (query) => {
            query.push("remote_utility_id", utilityId);
            if (tab) query.push("tab", tab);
            if (page) query.push("page", page);
            if (limit) query.push("limit", limit);
            return query;
        }
    );
    const response = await mxApiClient.get(url);
    return response.data ?? {};
};

export const startOperation = async (operationId: string | number): Promise<any> => {
    const url = ApiEndpoints.createUrlWithQueryParameters("mx", `operation/${operationId}/start`, (query) => query);
    const response = await mxApiClient.patch(url, {});
    return response.data;
};

export const confirmRetirement = async (operationId: string | number, payload: any): Promise<any> => {
    const url = ApiEndpoints.createUrlWithQueryParameters("mx", `operation/${operationId}/confirm-retirement`, (query) => query);
    const response = await mxApiClient.post(url, payload);
    return response.data;
};

export const markRetired = async (operationId: string | number): Promise<any> => {
    const url = ApiEndpoints.createUrlWithQueryParameters("mx", `operation/${operationId}/mark-retired`, (query) => query);
    const response = await mxApiClient.patch(url, {});
    return response.data;
};

export const completeRepair = async (operationId: string | number, payload: any): Promise<any> => {
    const url = ApiEndpoints.createUrlWithQueryParameters("mx", `operation/${operationId}/complete-repair`, (query) => query);
    const response = await mxApiClient.post(url, payload);
    return response.data;
};

export const returnToInventory = async (operationId: string | number, payload: any): Promise<any> => {
    const url = ApiEndpoints.createUrlWithQueryParameters("mx", `operation/${operationId}/return-to-inventory`, (query) => query);
    const response = await mxApiClient.patch(url, payload);
    return response.data;
};

export const getReplacementOptions = async (operationId: string | number): Promise<any> => {
    const url = ApiEndpoints.createUrlWithQueryParameters("mx", `operation/${operationId}/replacement-options`, (query) => query);
    const response = await mxApiClient.get(url);
    return response.data;
};

export const completeReplacement = async (operationId: string | number, payload: FormData): Promise<any> => {
    const url = ApiEndpoints.createUrlWithQueryParameters("mx", `operation/${operationId}/complete-replacement`, (query) => query);
    const response = await mxApiClient.post(url, payload, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
    return response.data;
};

export const getJobCardPriorities = async (): Promise<any> => {
    const url = ApiEndpoints.createUrlWithQueryParameters("mx", `choices/job_card_priority`, (query) => query);
    const response = await mxApiClient.get(url);
    return response.data;
};

export const getAllSops = async (remoteUtilityId: string | number): Promise<any> => {
    const url = ApiEndpoints.createUrlWithQueryParameters("mx", `get-all-sops`, (query) => {
        query.push("remote_utility_id", remoteUtilityId);
        query.push("association_type", "METER");
        query.push("is_active", "true");
        return query;
    });
    const response = await mxApiClient.get(url);
    return response.data;
};

export const raiseServiceOrder = async (operationId: string | number, payload: any): Promise<any> => {
    const url = ApiEndpoints.createUrlWithQueryParameters("mx", `operation/${operationId}/raise-service-order`, (query) => query);
    const response = await mxApiClient.post(url, payload);
    return response.data;
};

export const getWorkOrderJobCards = async (remoteUtilityId: string | number, operationId: string | number, page: number = 1, limit: number = 50): Promise<any> => {
    const url = ApiEndpoints.createUrlWithQueryParameters("mx", `work-order-job-card`, (query) => {
        query.push("remote_utility_id", remoteUtilityId.toString());
        query.push("operation_id", operationId.toString());
        query.push("page", page.toString());
        query.push("limit", limit.toString());
        query.push("association_type", "METER");
        return query;
    });
    const response = await mxApiClient.get(url);
    return response.data;
};
